export const CANADIAN_PROVINCES = [
    { name: 'Alberta', code: 'AB' },
    { name: 'British Columbia', code: 'BC' },
    { name: 'Manitoba', code: 'MB' },
    { name: 'New Brunswick', code: 'NB' },
    { name: 'Newfoundland and Labrador', code: 'NL' },
    { name: 'Nova Scotia', code: 'NS' },
    { name: 'Northwest Territories', code: 'NT' },
    { name: 'Nunavut', code: 'NU' },
    { name: 'Ontario', code: 'ON' },
    { name: 'Prince Edward Island', code: 'PE' },
    { name: 'Quebec', code: 'QC' },
    { name: 'Saskatchewan', code: 'SK' },
    { name: 'Yukon', code: 'YT' },
];
export const CANADIAN_PROVINCE_CODES = CANADIAN_PROVINCES.map(({ code }) => code);
const CANADIAN_PROVINCES_BY_CODE = Object.freeze(Object.fromEntries(CANADIAN_PROVINCES.map((x) => [x.code, x])));
const NON_OPERATING_CANADIAN_PROVINCE_CODES = [
    'QC',
];
export const OPERATING_CANADIAN_PROVINCE_CODES = CANADIAN_PROVINCE_CODES.filter((code) => !NON_OPERATING_CANADIAN_PROVINCE_CODES.some((excluded) => excluded === code));
/** Looks up a {@link CanadianProvince} by its {@link CanadianProvinceCode}. */
export const lookupCanadianProvince = (provinceCode) => CANADIAN_PROVINCES_BY_CODE[provinceCode];
/**
 * Narrows an arbitrary string to a Canadian province code, whether or not
 * Owner operates there.
 *
 * @param value province code to check
 */
export const isCanadianProvinceCode = (value) => CANADIAN_PROVINCE_CODES.some((code) => code === value);
/**
 * Narrows an arbitrary string to a Canadian province Owner operates in.
 * @param value province code to check
 */
export const isOperatingCanadianProvinceCode = (value) => OPERATING_CANADIAN_PROVINCE_CODES.some((code) => code === value);
//# sourceMappingURL=canadianProvinces.js.map